import * as React from 'react';

export function Avatar({
  className = '',
  size = 'default',
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & { size?: 'sm' | 'default' | 'lg' }) {
  const sizeClass = size === 'sm' ? 'shadcn-avatar-sm' : size === 'lg' ? 'shadcn-avatar-lg' : '';
  return (
    <div className={`shadcn-avatar ${sizeClass} ${className}`.trim()} {...props}>
      {children}
    </div>
  );
}

export function AvatarImage({
  src,
  alt = '',
  className = '',
  ...props
}: React.ImgHTMLAttributes<HTMLImageElement>) {
  const [error, setError] = React.useState(false);
  if (!src || error) return null;
  return (
    <img
      src={src}
      alt={alt}
      onError={() => setError(true)}
      className={`shadcn-avatar-img ${className}`.trim()}
      {...props}
    />
  );
}

export function AvatarFallback({
  className = '',
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={`shadcn-avatar-fallback ${className}`.trim()} {...props}>
      {children}
    </div>
  );
}
